import { limitInteger18 } from '@/utils/validate'

export default function () {
  const leaseFormList = [
    {
      el: 'input',
      itemConfig: {
        label: '总押金',
        prop: 'deposit',
      },
      elConfig: {
        events: {
          input: (e) => {
            limitInteger18(e, (ee) => {
              this.$set(this.renderData.model.leaseModel, 'deposit', ee)
            })
          },
        },
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '一次性管理费',
        prop: 'manageFee',
      },
      elConfig: {
        events: {
          input: (e) => {
            limitInteger18(e, (ee) => {
              this.$set(this.renderData.model.leaseModel, 'manageFee', ee)
            })
          },
        },
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '其他服务费',
        prop: 'serviceFee',
      },
      elConfig: {
        events: {
          input: (e) => {
            limitInteger18(e, (ee) => {
              this.$set(this.renderData.model.leaseModel, 'serviceFee', ee)
            })
          },
        },
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '备注',
        prop: 'remarks',
      },
      elConfig: {
        type: 'textarea',
        maxlength: 500,
        events: {
          input: (e) => {
            limitInteger18(e, () => {
              // this.$set(this.configData.formData.formProps.model, 'id', e)
            })
          },
        },
      },
    },
  ]
  const leaseModel = {}
  return {
    leaseFormList,
    leaseModel,
  }
}
